import { TypedDocumentNode, gql } from '@apollo/client';

import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { createCardSorts } from '@sorare/core/src/lib/algolia';

import useDefaultFilters from '@sorare/marketplace/src/hooks/useDefaultFilters';

import { NBACardSearch } from 'components/searchCards/NBACardSearch';
import { clubPageFilters } from 'components/searchCards/cardFilters';

import { NBATeamSearch_team } from './__generated__/index.graphql';

interface Props {
  team: NBATeamSearch_team;
}

const cardSorts = createCardSorts({ withHighestAverageScore: true });

export const Search = ({ team }: Props) => {
  const filters = useDefaultFilters({
    teamSlug: team.slug,
    excludePrimaryOffers: true,
  });

  return (
    <FullWidthContainer>
      <NBACardSearch
        analyticsTags={['Team', 'NBA']}
        topic={{ type: 'team', label: team.name }}
        defaultFilters={filters}
        cardFilters={clubPageFilters}
        sorts={cardSorts}
        defaultSort="Newly Listed"
      />
    </FullWidthContainer>
  );
};

Search.fragments = {
  team: gql`
    fragment NBATeamSearch_team on TeamInterface {
      slug
      name
    }
  ` as TypedDocumentNode<NBATeamSearch_team>,
};

export default Search;
